<template>
  <div>
    <div class="w-full pb-4 xl:pb-6">
      <Navigation :step="1" />

      <div class="w-full viewport-gutter">
        <div class="container">
          <div class="text-sm xl:text-lg">
            <h1 class="pb-2 text-xl font-bold leading-tight uppercase xl:text-3.25xl text-sn-secondary">
              {{ $t('pages.home.title') }}
            </h1>
            <p class="leading-tight">
              {{ $t('pages.home.subtitle') }}
            </p>
            <p class="pt-3 font-bold leading-tight">
              {{ $t('pages.home.multi_voucher_text', { maxVouchers }) }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <Form />
  </div>
</template>

<script lang="ts">
import Home from '~psp-pages/base/home/home.ts'

import Navigation from '~app/psp/brussels/navigation.vue'
import Form from './form.vue'

export default Home.extend({
  components: {
    Navigation,
    Form,
  },
})
</script>
